module.exports = __webpack_public_path__ + "img/TheUpstairsBar.c0cffe1f.webp";